export const EMAIL_STATUS = {
  PROCESSED: 'processed',
  DROPPED: 'dropped',
  DEFFERED: 'deferred',
  DELIVERED: 'delivered',
  OPEN: 'open',
  CLICK: 'click',
  BOUNCE: 'bounce',
  BLOCKED: 'blocked',
  SPAM_REPORT: 'spamreport',
  UNSUBSCRIBE: 'unsubscribe'
}
